import { AppEnum, DateFormatHelper, SoNumber, MandateEnums, RecordMap, TransactionEnums } from "@/Shared";
import {
    UserModel,
    ContactModel,
    MandateModel,
    TransactionModel,
    PropertyModel,
    NeedModel,
} from "@/Domains";

import { TransactionFormValues } from "..";
import { OptionHelper } from "@/Shared/Helpers/form-option.helpers";

export interface TransactionFVMParams {
    viewEnums: TransactionEnums;
    mandateEnums: MandateEnums;
    contactMap: RecordMap<ContactModel>;
    agentMap: RecordMap<UserModel>;
    mandateMap: RecordMap<MandateModel>;
    enrichedTransaction?: TransactionModel;
    propertyMap : RecordMap<PropertyModel>;
    needMap : RecordMap<NeedModel>
    mandate ? : MandateModel 
}


export class TransactionFormViewModel {

    private _userOptions = [] as AppEnum[];
    private _propertyOptions = [] as AppEnum[];
    private _needOptions = [] as AppEnum[];
    private _clientOptions = [] as AppEnum[];
    private _mandateOptions = [] as AppEnum[];

    private _viewEnums: TransactionEnums;
    private _mandateEnums: MandateEnums;

    private _mandateMap: RecordMap<MandateModel>;
    private _model?: TransactionModel;
    private _mandate? : MandateModel;

    

    public constructor(protected params: TransactionFVMParams) {

        const { contactMap, agentMap, mandateMap, propertyMap, needMap } = this.params;

        this._viewEnums = this.params.viewEnums;
        this._mandateEnums = this.params.mandateEnums;


        this._mandateMap = mandateMap;
        this._model = this.params.enrichedTransaction;
        this._mandate = this.params.mandate;


        this._userOptions = OptionHelper.userOptions(agentMap.toArray());
        this._clientOptions = OptionHelper.contactOptions(contactMap.toArray());
        this._mandateOptions = OptionHelper.mandateOptions(mandateMap.toArray(), this._mandateEnums);

        this._propertyOptions = OptionHelper.propertyOptions(propertyMap.toArray(), this._viewEnums.PropertyTypeEnum);
        this._needOptions = OptionHelper.needOptions(
            needMap.toArray(), 
            this._viewEnums.PropertyTypeEnum, 
            this._mandateEnums.NeedStatusEnum
        );
    }


    get formValues() {
        return {
            advisorId: this._model?.advisorId,
            clientId: this._model?.clientId,
            transactionDate: DateFormatHelper.toInput(this._model?.transactionDate),
            bookingDate: DateFormatHelper.toInput(this._model?.bookingDate),
            mandateId: this._model?.mandateId ?? this._mandate?.id,
            mandateType : this._model?.mandateType ?? this._mandate?.mandateType,
            propertyId : this._model?.propertyId ?? this._mandate?.propertyId,
            needId : this._model?.needId,

            operationPrice: SoNumber.formatAmount(this._model?.operationPrice ?? this._mandate?.totalPriceHt),
            
            serviceChargeProvision: SoNumber.formatAmount(this._model?.serviceChargeProvision ?? this._mandate?.property?.serviceChargeProvision),
            
            acMaintenanceCharge: SoNumber.formatAmount(this._model?.acMaintenanceCharge ?? this._mandate?.property?.acMaintenanceCharge),
            
            securityDeposit: SoNumber.formatAmount(this._model?.securityDeposit ?? this._mandate?.property?.securityDeposit),
            comRate: this._model?.comRate ?? this._mandate?.feeRate,
            agencyCom: SoNumber.formatAmount(this._model?.agencyCom ?? this._mandate?.agencyComHt),
            
            clientCom: SoNumber.formatAmount(this._model?.clientCom),
            ownerCom: SoNumber.formatAmount(this._model?.ownerCom)
        } as TransactionFormValues;
    }

    handleMandateChange(value? : string | number | null) {
        const data = {
            mandateId : value,
            mandateType : "",
            propertyId : "",
            needId : ""
        };

        if(value && !isNaN(+value)) {
            const mandate = this._mandateMap.find(m => m.id === Number(value))
            if(mandate) {
                data.mandateType = mandate.mandateType;
                data.propertyId = String(mandate.propertyId ?? "");
                data.needId = String(mandate.needId ?? "");
            }
        }

        console.table(data);

        return data;
    }

    get id() { return this._model?.id; }

    /**
     * Returns selectable property options.
     */
    get propertyOptions(): AppEnum[] {
        return this._propertyOptions;
    }

    /**
    * Returns selectable need options.
    */
    get needOptions(): AppEnum[] {
        return this._needOptions;
    }


    get mandateTypeOptions(): AppEnum[] {
        return OptionHelper.sortByLabel(this._viewEnums.MandateTypeEnum);
    }

    get mandateOptions(): AppEnum[] {
        return [{ key: "", value: "", label: "Choisir un mandat" }, ...this._mandateOptions]
    }

    get userOptions(): AppEnum[] {
        return [{ key: "", value: "", label: "Choisir un référent" }, ...this._userOptions]
    }

    get clientOptions(): AppEnum[] {
        return [{ key: "", value: "", label: "Choisir un client" }, ...this._clientOptions];
    }


    get title() {
        return this._model ? "Transaction N° " + this.id + " - " :
            "Création de transaction";
    }
}